import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./Gray_Btn.css";

const Gray_Btn = (props) => {
  return (
    <button className="Gray_Btn" onClick={props?.onClick} type="button">
      {props?.icon && (
        <div className="icon_holder">
          <FontAwesomeIcon icon={props?.icon} className="icon" />
        </div>
      )}
      <p className="btn_text">{props?.btn_name}</p>
    </button>
  );
};

export default Gray_Btn;
